export default __webpack_public_path__ + "static/impact-50f88260ab0d059b94c361ecb5525d6b.png";